import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./locales/en.json";
import sw from "./locales/sw.json";
import es from "./locales/es.json";
import fr from "./locales/fr.json";

export const SUPPORTED_LANGS = ["en", "sw", "es", "fr"];

export const LANG_LABELS = {
  en: "English",
  sw: "Kiswahili",
  es: "Español",
  fr: "Français",
};

const resources = {
  en: { translation: en },
  sw: { translation: sw },
  es: { translation: es },
  fr: { translation: fr },
};

// IMPORTANT:
// - Web: detects from browser (navigator.languages)
// - Mobile web: same
// - If later you ship native apps, this still works in the webview
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    supportedLngs: SUPPORTED_LANGS,
    nonExplicitSupportedLngs: true, // maps fr-FR -> fr
    interpolation: { escapeValue: false },
    detection: {
      // priority order:
      // 1) explicit user choice saved in localStorage
      // 2) browser language
      // 3) fallbackLng
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "ul_lang",
    },
    react: { useSuspense: false },
  });

export default i18n;
